/* eslint-disable camelcase */
import _ from "underscore";

// The resulting string will be consumed as html
// noLinks: boolean - will disable links but wrap them in <span class="fakeTwitterLink>"
const formTweetString = (params) => {
	let { text, userMentions, hashtags, urls, noLinks } = params;

	if (!text) {
		return "<em style='font-style: italic'>No text contained in post</em>";
	}

	// const regex = /^\u2026/i; // did't work
	const linkOffset = 20;
	let offsetDiff = 0;
	text = text || "";

	const orderedLinks = _.sortBy([...userMentions, ...hashtags, ...urls], (link) => {
		return link.indices && link.indices[0];
	});

	_.each(orderedLinks, (linkObj) => {
		const { hashtag, indices, screenName, screen_name, url, display_url } = linkObj;
		if (url) {
			// prettier-ignore
			const urlString = noLinks 
				? `<span>${display_url || prettySlice({ url, linkOffset })}${display_url ? "" : "..."}</span>`
				:	`<a href="${url}" target="_blank">${display_url || prettySlice({ url, linkOffset })}${display_url ? "" : "..."}</a>`;
			const beforeText = text.slice(0, indices[0] + offsetDiff);
			const afterText = text.slice(indices[1] + offsetDiff);

			// Remove excess ellipses
			text = `${beforeText}${urlString}${afterText.replace("\u2026", "")}`;

			offsetDiff = offsetDiff + indices[0] - indices[1] + urlString.length;
		}

		if (screenName || screen_name) {
			// prettier-ignore
			const urlString = noLinks 
				? `<span>@${screenName || screen_name}</span>`
				:	`<a href="https://twitter.com/${screenName || screen_name}" target="_blank">@${screenName || screen_name}</a>`;
			const beforeText = text.slice(0, indices[0] + offsetDiff);
			const afterText = text.slice(indices[1] + offsetDiff);

			text = `${beforeText}${urlString}${afterText}`;

			offsetDiff = offsetDiff + indices[0] - indices[1] + urlString.length;
		}

		if (hashtag || linkObj.text) {
			const hashlessText = linkObj.text ? linkObj.text.slice(1) : hashtag; // linkObj.text includes "#"
			// prettier-ignore
			const urlString = noLinks 
				? `<span>${hashlessText}</span>`
				:	`<a href="https://twitter.com/hashtag/${hashlessText}" target="_blank">${hashlessText}</a>`;
			const beforeText = text.slice(0, indices[0] + offsetDiff);
			const afterText = text.slice(indices[1] + offsetDiff);

			text = `${beforeText}${urlString}${afterText}`;

			offsetDiff = offsetDiff + indices[0] - indices[1] + urlString.length;
		}
	});

	return text;
};

// slice off the ugly bits & truncate the rest
const prettySlice = (params) => {
	const { url, linkOffset } = params;
	const regex = /^(http:\/\/www.|https:\/\/www.|http:\/\/|https:\/\/)/i;

	const cleanUrl = url.replace(regex, "");

	return cleanUrl.slice(0, linkOffset);
};

export default formTweetString;

// console.log(formTweetString({
// 	text: "this link is hugungous https://www.thedenverchannel.com/news/coronavirus/colorado-governor-grateful-for-100-ventilators-promised-by-president-trump-says-communication-is-key while this next one is not https://twitter.com/DailySentinelGJ/status/1248258808780070913 that big, man",
// 	urls: [
// 		{
// 			url: "https://www.thedenverchannel.com/news/coronavirus/colorado-governor-grateful-for-100-ventilators-promised-by-president-trump-says-communication-is-key",
// 			indices: [23, 173],
// 		},
// 		{
// 			url: "https://twitter.com/DailySentinelGJ/status/1248258808780070913",
// 			indices: [201, 263]
// 		}
// 	]
// }))
